import { useEffect, useState } from "react";
import { track } from "../lib/track";
import { useApp } from "../state/AppState";

/** Appel à l'action collant, mobile uniquement, visible sur l'accueil. */
export function StickyCta() {
  const { view, goTo } = useApp();
  const surAccueil = view === "home";

  /*
    Elle n'apparaît qu'une fois le bouton du héros sorti de l'écran —
    25/08/2026.

    Elle s'affichait dès l'arrivée, si bien que **deux boutons dorés portant le
    même texte** cohabitaient dans le premier écran : celui de la carte et
    celui de la barre. Deux appels identiques au même moment ne se renforcent
    pas, ils se diluent — et le troisième, « lancer le diagnostic » en tête de
    page, faisait trois chemins pour une seule intention.

    Un observateur d'intersection plutôt qu'un calcul au défilement : le
    navigateur fait le travail hors du fil principal, et rien ne se recalcule
    à chaque pixel sur un téléphone d'entrée de gamme.

    Si la cible n'existe pas — un écran sans héros —, la barre reste affichée :
    mieux vaut un appel de trop qu'un produit sans porte de sortie.
  */
  const [depasse, setDepasse] = useState(false);

  useEffect(() => {
    if (!surAccueil) return;
    const cible = document.getElementById("hero-job");
    if (cible === null) {
      setDepasse(true);
      return;
    }
    const observateur = new IntersectionObserver(
      ([entree]) => setDepasse(entree !== undefined && !entree.isIntersecting),
      { rootMargin: "-72px 0px 0px 0px" },
    );
    observateur.observe(cible);
    return () => observateur.disconnect();
  }, [surAccueil]);

  const visible = surAccueil && depasse;

  /*
    La barre est posée en `fixed` : elle ne pousse rien, et rien ne lui
    réservait de place ailleurs que sous le pied de page. Ses soixante-sept
    pixels opaques recouvraient donc en permanence le bas de tout ce qui n'est
    pas le pied — la fin du comparatif, les mentions de droits — et aucun
    défilement ne pouvait l'atteindre, puisque la barre suit l'écran.

    Le sélecteur de voisinage ne pouvait pas régler ça : en CSS, on ne remonte
    pas au parent. On marque donc le document tant que la barre existe, et la
    réserve s'applique à la page entière. Le marqueur disparaît avec elle : hors
    de l'accueil, aucune place n'est réservée pour rien.
  */
  useEffect(() => {
    if (!surAccueil) return;
    document.body.dataset.barreCollante = "1";
    return () => {
      delete document.body.dataset.barreCollante;
    };
  }, [surAccueil]);

  if (!visible) return null;

  return (
    <div className="sticky-cta">
      {/* « 40 secondes » était la durée d'aucune étape réelle : l'analyse seule
          en mesure vingt-deux à trente-sept, avant la saisie du métier, la
          déclaration des durées et la lecture du résultat. */}
      <p>Gratuit · moins de deux minutes</p>
      <button
        type="button"
        onClick={() => {
          track("cta_click", { from: "sticky-go" });
          /*
            Vers le champ de l'accueil, pas vers un second formulaire —
            09/10/2026. Sur petit téléphone, la barre s'affiche dès l'arrivée
            (le champ est sous le bord) et menait à l'écran du volet 1 : un
            écran de plus, d'autres exemples, pour la même saisie.
          */
          const champ = document.getElementById("hero-job");
          if (champ instanceof HTMLInputElement) {
            champ.scrollIntoView({ block: "center" });
            champ.focus({ preventScroll: true });
          } else {
            goTo("s-t1");
          }
        }}
      >
        Voir mon indice
      </button>
    </div>
  );
}
